import React, { useEffect } from 'react'
import headerRoundImg from "../Assets/darkHotPink.webp"
import headerRotatingImg from "../Assets/largeMovingBox.webp"

import Aos from 'aos';

export default function Header() {
  useEffect(() => {
    window.addEventListener("DOMContentLoaded" , () => {
      setTimeout(() => {
        Aos.refresh();
      },500)
    })
    Aos.init({duration:1000});
  })
  return (
    <>
      <header>
        <div className="headerSection">
            <div className="Block">
                <h2 data-aos="fade-up" data-aos-delay="0">YOUR TRUSTED</h2>
                <h1 data-aos="fade-up" data-aos-delay="300"><span>Interior</span> Design Partner for Home or Office</h1>
                <p data-aos="fade-up" data-aos-delay="600">GET A FREE QUOTE</p>
            </div>
        </div>
        <figure className='homebackground'>
         {/* <img src={headerBgImg} alt="" /> */}
        </figure>
        <div className="bigHotPink">
            <img src={headerRoundImg} alt="" />
        </div>
        <div className="rotatingImg">
            <img src={headerRotatingImg} alt="" />
        </div>
      </header>

    </>
  )
}
